import { Base } from './Base';
import Typography from '../interfaces/Typography';
import Colors from '../interfaces/Colors';
import Framing from '../interfaces/Framing';

export default class CustomerDesktopBase {

    private static readonly colorPalette = new Base().getColorsPalette;

    static setShareStyles (base: Base): Base {
        base.colors = this.setColors(base.colors);
        base.framing = this.setFraming(base.framing);
        base.typography = this.setTypography(base.typography);
        
        return base;
    };

    private static setColors (colors: Colors): Colors {
        colors.general.disabledColor = this.colorPalette.gray;

        colors.hover.secondaryHoverColor = this.colorPalette.grayDarker;

        colors.border.primaryBorder = this.colorPalette.gray;

        colors.background.blueBackgroundColor = this.colorPalette.blue;

        colors.button.secondaryButtonText = this.colorPalette.white;

        colors.modal.headerBackground = this.colorPalette.white;
        colors.modal.headerBorder = this.colorPalette.gray;

        colors.table.headerBackground = this.colorPalette.white;
        colors.table.oddRowsBackground = this.colorPalette.grayLight;
        colors.table.evenRowsBackground = 'none';
        
        colors = this.setDeprecatedColors(colors);
        
        return colors;
    };

    private static setDeprecatedColors (colors: Colors): Colors {
        /** @deprecated since version 0.2.*, use general.disabledColor */
        colors.general.primaryDisabledColor = this.colorPalette.gray;
        /** @deprecated since version 0.2.*; use general.disabledColor */
        colors.general.secondaryDisabledColor = this.colorPalette.gray;
    
        return colors;
    };

    private static setFraming (framing: Framing): Framing {
        framing.button.border = '0';

        framing.table.innerBorder = '0';

        framing.modal.headerSpace.padding = '0';
        framing.modal.headerSpace.margin = '15px 15px 0';
        framing.modal.headerBorder = '1px solid';
        
        return framing;
    };

    private static setTypography (typography: Typography): Typography {
        
        return typography;
    };
}


// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/themes/CustomerDesktopBase.ts